"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _VariancePicker = _interopRequireDefault(require("./VariancePicker"));
var _MediaGallery = _interopRequireDefault(require("./MediaGallery"));
var _Prices = _interopRequireDefault(require("./Prices"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SelectInputsWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var ProductInfo = function ProductInfo(_ref) {
  var handset = _ref.handset;
  var media = handset.media;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "recommendation-handset-name"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, handset.productName)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 1,
      md: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_MediaGallery.default, {
    media: media
  }), /*#__PURE__*/_react.default.createElement(SelectInputsWrapper, null, /*#__PURE__*/_react.default.createElement(_Prices.default, null), /*#__PURE__*/_react.default.createElement(_VariancePicker.default, {
    handset: handset
  }))));
};
var _default = ProductInfo;
exports.default = _default;